"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
const Flex = styled_components_1.styled.div.attrs((props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    return ({
        notParent: (_a = props.notParent) !== null && _a !== void 0 ? _a : false,
        col: (_b = props.col) !== null && _b !== void 0 ? _b : false,
        align: (_c = props.align) !== null && _c !== void 0 ? _c : "stretch",
        justify: (_d = props.justify) !== null && _d !== void 0 ? _d : "flex-start",
        noWrap: (_e = props.noWrap) !== null && _e !== void 0 ? _e : false,
        noResize: (_f = props.noResize) !== null && _f !== void 0 ? _f : false,
        noGrow: (_g = props.noGrow) !== null && _g !== void 0 ? _g : false,
        flex: (_h = props.flex) !== null && _h !== void 0 ? _h : "1 1 auto",
        noOverflow: (_j = props.noOverflow) !== null && _j !== void 0 ? _j : false,
        overflow: props.overflow,
        relative: (_k = props.relative) !== null && _k !== void 0 ? _k : false,
        style: (_l = props.style) !== null && _l !== void 0 ? _l : {},
        padding: (_m = props.padding) !== null && _m !== void 0 ? _m : "0",
        margin: (_o = props.margin) !== null && _o !== void 0 ? _o : "0",
        darken: (_p = props.darken) !== null && _p !== void 0 ? _p : false,
        lighten: (_q = props.lighten) !== null && _q !== void 0 ? _q : false,
        rounded: (_r = props.rounded) !== null && _r !== void 0 ? _r : false,
    });
}) `
  background: ${(props) => props.darken
    ? "rgba(0,0,0,0.1)"
    : props.lighten
        ? "rgba(255, 255, 255, 0.05)"
        : null};
  position: ${(props) => (props.relative ? "relative" : "auto")};
  display: ${(props) => (props.notParent ? "block" : "flex")};
  flex-direction: ${(props) => (props.col ? "column" : "row")};
  align-items: ${(props) => props.align || "stretch"};
  justify-content: ${(props) => props.justify || "flex-start"};
  flex-wrap: ${(props) => (props.noWrap ? "nowrap" : "wrap")};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  flex: ${(props) => props.noResize ? "0 0 auto" : props.noGrow ? "0 1 auto" : props.flex};
  overflow: ${(props) => { var _a; return props.noOverflow ? "hidden" : ((_a = props.overflow) !== null && _a !== void 0 ? _a : "visible"); }};
  padding: ${(props) => props.padding};
  margin: ${(props) => props.margin};
  border-radius: ${(props) => (props.rounded ? props.theme.radius : 0)};
`;
exports.default = Flex;
//# sourceMappingURL=Flex.js.map